<template>
  <div>
    <!-- Header -->

    <button type="button" class="btn btn-primary" @click="send()" v-if="1 == 0">Enviar Teste...</button>
    <video id="beepElementId" src="https://api.klingo.app/message.ogg" style="display: none;" ></video>

    <div class="card dashcard mb-0">

      <div class="card-body">

        <div class="form-row">
          <div class="col col-12 col-md-3">
            <div class="input-group mb-1">
              <div class="input-group-prepend">
                <button type="button" class="btn btn-outline-primary" @click="load(false)" :disabled="$store.state.loading" id="refresh-button">
                  <i class="fas fa-sync-alt fa-fw"></i>
                </button>
              </div>
              <input type="date" class="form form-control" v-model="referencia" v-shortkey.focus="['ctrl', 'd']" @change="ativar_rebuscar()" id="ref-data" />
              <div class="input-group-append">
                <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ turno }}</button>
                <div class="dropdown-menu">
                  <a class="dropdown-item" :class="turno == 'G' ? 'active' : ''" href="#" @click.prevent="turno = 'G'">Geral</a>
                  <a class="dropdown-item" :class="turno == 'M' ? 'active' : ''" href="#" @click.prevent="turno = 'M'">Turno Matutino</a>
                  <a class="dropdown-item" :class="turno == 'V' ? 'active' : ''" href="#" @click.prevent="turno = 'V'">Turno Vespertino</a>
                  <a class="dropdown-item" :class="turno == 'N' ? 'active' : ''" href="#" @click.prevent="turno = 'N'">Turno Noturno</a>
                </div>
              </div>
            </div>
          </div>

          <div class="col col-12 col-md-3">
            <az-input
              placeholder="Todas as Especialidades..."
              icon="fas fa-filter"
              type="select"
              optionsMode="esp-ativas"
              optionsName="esp-ativas"
              optionsData="id_especialidade"
              v-model="viewEspec"
              @input="load(false)" />

            <div class="input-group mb-1" v-if="false">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1">
                  <i class="fas fa-filter fa-fw"></i>
                </span>
              </div>
              <select class="form form-control" v-model="viewEspec" @change="load(false)">
                <option value>Todas as Especialidades...</option>
                <template v-if="lista_especialidades">
                  <option
                    :value="item.id"
                    v-for="(item, index) in lista_especialidades"
                    :key="index"
                  >{{ item.quebra }}</option>
                </template>
              </select>
            </div>
          </div>

          <div class="col col-12 col-md-3">
            <div class="input-group mb-1">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1">
                  <i class="fas fa-user-md fa-fw"></i>
                </span>
              </div>

              <template v-if="filtro_lista_medicos && filtro_lista_medicos.length">
                <input class="form form-control" value="Lista Selecionada" disabled />
              </template>

              <template v-else>
                <select class="form form-control" v-model="medico" @change="load()" id="filtro-medico">
                  <option value>Todos os Profissionais...</option>
                  <template v-if="lista_medicos">
                    <option
                      :value="item.id_pessoa"
                      v-for="(item, index) in lista_medicos"
                      :key="index"
                    >{{ item.st_nome_exibicao }}</option>
                  </template>
                </select>
              </template>

              <div class="input-group-append" v-if="!medico">
                <span class="input-group-text" id="basic-addon2" v-if="filtro_lista_medicos && filtro_lista_medicos.length">
                  {{ filtro_lista_medicos.length }}
                </span>
                <button class="btn btn-outline-secondary" type="button" id="button-addon2" data-toggle="tooltip" data-placement="top" title="Selecionar Profissionais"
                  @click="selecionar_medicos()">
                  <i class="fa-solid fa-list-check"></i>
                </button>
                <button class="btn btn-outline-secondary" type="button" id="button-addon2" data-toggle="tooltip" data-placement="top" title="Agrupar/Desagrupar por Profissionais"
                  @click="viewMode == 'A' ? viewMode = 'G' : viewMode = 'A'">
                  <i class="fas fa-object-group fa-fw" v-if="viewMode == 'A'"></i>
                  <i class="fas fa-object-ungroup fa-fw" v-else></i>
                </button>
              </div>

              <div class="input-group-append" v-else>
                <button class="btn btn-outline-secondary" type="button" id="button-addon2" data-toggle="tooltip" data-placement="top" title="Selecionar Profissionais"
                  @click="selecionar_medicos()">
                  <i class="fa-solid fa-list-check"></i>
                </button>
                <button class="btn btn-outline-secondary" type="button" id="button-addon2" data-toggle="tooltip" data-placement="top" title="Ver Fila" @click="ver_fila_medico(medico)">
                  <i class="fa-solid fa-person-walking-dashed-line-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="col col-12 col-md-3">
            <div class="input-group mb-1">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1">
                  <i class="fas fa-search fa-fw" v-if="!search || !$store.state.loading"></i>
                  <div class="spinner-grow spinner-grow-sm" role="status" v-else>
                    <span class="sr-only">Loading...</span>
                  </div>
                </span>
              </div>
              <input
                id="filtro-pesquisar"
                type="text"
                class="form form-control"
                :disabled="$store.state.loading"
                v-shortkey.focus="['ctrl', 'p']"
                v-model="search"
                :placeholder="$store.state.loading ? 'Pesquisando...' : 'Pesquisar...'"
                @input="pesquisar()"
                @keyup.enter="load(false)"
              />
              <div class="input-group-append">
                <button
                  id="novo-atendimento"
                  type="button"
                  class="btn btn-outline-primary text-nowrap text-truncate"
                  @click="novoAtendimento()"
                  style="width:100%;">
                  <i class="fas fa-plus"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mt-2" v-if="medico">
          <div class="col col-12 d-flex flex-column">
            <div class="btn-group mb-2" role="group" aria-label="Basic example">
              <button type="button" class="btn btn-sm"
                :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'"
                @click="trocar_view_mode('A')"
                :disabled="id_fila_laudo ? true : false">
                <i class="far fa-calendar-check mr-2"></i>
                Marcações
              </button>

              <button
                type="button" class="btn btn-sm"
                :class="viewMode == 'G' ? 'btn-secondary' : 'btn-outline-secondary'"
                @click="trocar_view_mode('G')"
                :disabled="id_fila_laudo ? true : false">
                <i class="far fa-calendar mr-2"></i>
                Livres
              </button>

              <button
                type="button" class="btn btn-sm"
                :class="viewMode == 'B' ? 'btn-secondary' : 'btn-outline-secondary'"
                @click="trocar_view_mode('B')"
                :disabled="id_fila_laudo ? true : false">
                <i class="fa fa-ban mr-2" aria-hidden="true"></i>
                Bloqueados
              </button>
            </div>
          </div>
        </div>

        <!-- Filtros por Status -->
        <template v-else>
          <div class="form-row mt-2">
            <div class="col col-12 d-flex flex-column" :class="filtrar_faixa_hora ? 'col-md-9' : ''">
              <div class="btn-group" role="group" id="filtro-status">
                <button type="button" class="btn text-nowrap text-truncate btn-sm mb-1"
                  :class="viewStatus == botao.ordem ? 'btn-secondary' : 'btn-outline-secondary'"
                  @click="filtrar_status(botao.ordem)"
                  v-for="(botao, ibx) in lista_filtros_exibicao" :key="ibx">
                  <i v-if=" 1 == 0 " :class="botao.icon" class="mr-2"></i>
                  {{ botao.quebra }}
                </button>

                <button type="button" class="btn text-nowrap text-truncate btn-sm mb-1"
                  :class="viewStatus == 'RP' ? 'btn-secondary' : 'btn-outline-secondary'"
                  @click="filtrar_status('RP')">
                  Pagamentos
                </button>
              </div>
            </div>

            <div class="col col-12 col-md-3" v-if="filtrar_faixa_hora">
              <az-input
                class="mb-1"
                id="filtro-horario"
                type="button-group"
                sizing="sm"
                :optionsList="[
                  { id: 'D', search: 'Dia', tooltip: 'Todos os pacientes do dia.' },
                  { id: '1', search: '1h', tooltip: 'Em atendimento e agendados no intervalo de mais ou menos 1 hora.' },
                  { id: '2', search: '2h', tooltip: 'Em atendimento e agendados no intervalo de mais ou menos 2 horas.' },
                  { id: '4', search: '4h', tooltip: 'Em atendimento e agendados no intervalo de mais ou menos 4 horas.' },
                  { id: 'C', search: 'C-In', tooltip: 'Check-In registrado.' },
                ]"
                optionsData="id"
                optionsDisplay="search"
                v-model="faixa_hora"
                :edicao="!$store.state.loading"
                @input="selecionar_faixa_hora()" />
            </div>
          </div>

          <div class="form-row mt-2" v-if="1 == 0 && lista_especialidades.length > 1">
            <div class="col col-12 d-flex flex-column">
              <div class="btn-group" role="group">
                <button type="button" class="btn text-nowrap text-truncate btn-sm"
                  :class="viewEspec == botao.id ? 'btn-secondary' : 'btn-outline-secondary'"
                  @click="viewEspec = botao.id"
                  v-for="(botao, ibx) in lista_especialidades" :key="ibx">
                  {{ botao.quebra }}
                </button>
              </div>
            </div>
          </div>
        </template>

        <div class="form-row mt-2" v-if="tem_recep_fila_proc && filas_proc && filas_proc.length">
          <div class="col col-12 col-md-9">
            <az-input
              icon="fas fa-bars fa-fw"
              type="select"
              sizing="sm"
              placeholder="Filtro pela fila de procedimento..."
              :optionsList="filas_proc.map(item => { return { id: item.id_fila_laudo, search: item.search } })"
              optionsData="id"
              optionsDisplay="search"
              v-model="id_fila_laudo"
              :edicao="!$store.state.loading && ( !medico || viewMode == 'A' )">
            </az-input>
          </div>
          <div class="col col-12 col-md-3">
            <az-input
              type="button-group"
              sizing="sm"
              :optionsList="[
                { id: 'T', search: 'Todos' },
                { id: 'C', search: 'Consultas' },
                { id: 'P', search: 'Outros' },
              ]"
              optionsData="id"
              v-model="tipo_proced"
              @click="alterar_tipo_proced()" />
          </div>
        </div>

      </div>

    </div>
    <!-- Fim Header -->

    <div class="progress mt-1 mb-2">
      <div class="indeterminate" v-if="$store.state.loading && exibicao"></div>
      <div class="determinate" v-else></div>
    </div>

    <!-- Lista de agendas -->
    <div class="mt-2" id="teste">
      <div v-if="outros && outros.length">
        <button type="button" class="btn btn-dark" @click="abrir_atend_outros(outros)">
          Outros
          <span class="badge badge-light ml-1">
            {{ outros.length }}
          </span>
        </button>

        <outros-chamada 
          class="mt-3" 
          v-if="outros.filter(item => item.fl_recepcao && item.id_etapa_atendimento != 7).length" 
          @search="set_nome_search"
          :agora="$util.hoje() + ' ' + agora"
          :link_search="true"
          :search="search"
          :outros="outros.filter(item => item.fl_recepcao)" 
          :na_recepcao="true"
          @refresh="load(false)" />
      </div>

      <div class="d-flex justify-content-between" v-if="( lista && lista.length ) || ( paginacao && paginacao.last_page > 1 ) || editados || apenas_editados">
        <div>
          <span class="badge badge-secondary" v-if="( paginacao && paginacao.last_page > 1 )" title="Atendimentos">
            {{ paginacao.from }} - {{ paginacao.to }}  / {{ paginacao.total }}
          </span>
          <template v-else>
            <span class="badge badge-secondary" title="Atendimentos">
              {{ lista.length }}
            </span>
            <template v-if="viewMode == 'G'">
                <a href="#" @click.prevent="filtrar_medico(items)" v-for="(items, grupo, iix) in exibicao" :key="iix">
                    <span class="badge badge-secondary ml-1">
                        {{ items.length }} / {{ grupo }}
                    </span>
                </a>
            </template>
            <template v-else>
                <a href="#" @click.prevent="set_texto_search(grupo)" v-for="(items, grupo, iix) in exibicao" :key="iix">
                <span class="badge badge-secondary ml-1">
                    {{ items.length }} / {{ grupo }}
                </span>
                </a>
            </template>
          </template>
        </div>
        <div>
          <a href="#" @click.prevent="buscar_editados()" v-if="editados || apenas_editados">
            <span class="badge badge-info">
              <i class="fa fa-check mr-2" aria-hidden="true" v-if="apenas_editados"></i>
              Editados: {{ editados ? editados : '0' }}
            </span>
          </a>

          <div v-if="conf_exibir_pacotes" class="ml-2">
            <a href="#" @click.prevent="filtro_teleatend = !filtro_teleatend; load(false)" title="Teleatendimentos.">
              <i class="fa-solid fa-satellite-dish mr-2" :class="!filtro_teleatend ? 'text-secondary' : 'text-primary'"></i>
            </a>

            <a href="#" @click.prevent="block_view_pacotes = !block_view_pacotes; load(false)" title="Visualizar sessões.">
              <i class="fa-solid fa-layer-group" :class="block_view_pacotes ? 'text-secondary' : 'text-primary'"></i>
            </a>
          </div>

          <div v-else class="ml-2">
            <a href="#" @click.prevent="filtro_teleatend = !filtro_teleatend; load(false)" title="Teleatendimentos.">
              <i class="fa-solid fa-satellite-dish" :class="!filtro_teleatend ? 'text-secondary' : 'text-primary'"></i>
            </a>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column mb-3" v-if="faixa_hora == 'C' && unidade_operacao && $util.getCookie('id_recepcao') && this.referencia == this.$util.hoje()">
        <az-submit color="outline-danger" @click="chamar_proximo_para_recepcao()">
          <i class="fas fa-volume-up mr-2"></i>
          Chamar Próximo
        </az-submit>
      </div>

      <div v-if="exibicao && Object.keys(exibicao).length !== 0">
        <div v-for="(agendas, nome) in exibicao" :key="nome">

          <az-break-title :title="nome" :link="true" :qtd="agendas.length" v-if="nome">
            <template v-slot:icon>
              <a href="#" @click.prevent="toggle_retracao(nome)">
                <i class="far fa-minus-square mr-2" v-if="!retracao[nome]"></i>
                <i class="far fa-plus-square mr-2" v-else></i>
              </a>
            </template>
          </az-break-title>

          <!-- @click="selecionarMedico(agendas)" -->

          <!-- classBorder(item.marcacao) + ' ' + classBackground(item.marcacao) -->

          <div class="mb-3" v-if="!retracao[nome]">
            <div v-for="(item, index) in agendas" :key="index" class="dashcard my-2" :class="item.marcacao ? item.marcacao.item_status.border + ' ' + item.marcacao.item_status.bg : 'bg-white'">
              <div class="row py-1 px-2 align-items-center">
                <!-- Ação -->
                <div class="col-12 col-md-2 col-lg-2 text-center my-2 my-md-auto">
                  <div class="d-flex flex-column" v-if="item.status == 'livre'">
                    <button class="btn btn-outline-primary btn-sm" @click="novoAtendimento(item)">
                      <i class="fas fa-clock mr-1"></i>
                      Agendar
                    </button>
                  </div>
                  <div class="d-flex flex-column" v-else-if="item.status == 'bloqueado' || ( item.marcacao && item.marcacao.ch_estado_marcacao == 'B' )">
                    <span class="badge badge-danger">BLOQUEADO</span>
                  </div>

                  <div v-else-if="item.marcacao && !item.marcacao.atendimento" class="d-flex flex-column">
                    <div class="btn-group" role="group" v-if="item.marcacao.dt_inicio.substr(0,10) <= $util.hoje() || pode_atend_futuro || ( item.marcacao.local && item.marcacao.local.fl_coleta_dom )">
                      <template v-if="false">
                        <a href="#" class="badge p-2 mr-1" :class="item.marcacao.st_local_recepcao ? 'badge-secondary' : 'badge-danger'"
                          @click.prevent="chamar_para_recepcao(item.marcacao)"
                          :disabled="item.marcacao.item_status.loading"
                          v-if="local && item.marcacao.dt_inicio.substr(0,10) == $util.hoje()" >
                          <i class="fas fa-volume-up"></i>
                        </a>
                        <a href="#" class="badge badge-success p-2" @click.prevent="iniciar(item.marcacao)">
                          <div class="spinner-border spinner-border-sm mr-1" role="status" v-if="item.marcacao.item_status.loading">
                            <span class="sr-only">Loading...</span>
                          </div>
                          <i class="fas fa-play mr-1" v-else></i>
                          Iniciar
                        </a>
                      </template>
                      <button
                        class="btn btn-sm fa-fw mr-1"
                        :class="item.marcacao.st_local_recepcao ? 'btn-outline-secondary' : 'btn-outline-danger'"
                        data-toggle2="tooltip" title="Chamar paciente"
                        @click="chamar_para_recepcao(item.marcacao)"
                        :disabled="item.marcacao.item_status.loading"
                        v-if="local && item.marcacao.dt_inicio.substr(0,10) == $util.hoje()">
                        <i class="fas fa-volume-up"></i>
                      </button>
                      <button class="btn btn-outline-success btn-sm" @click="iniciar(item.marcacao)"
                        :disabled="item.marcacao.item_status.loading">
                        <div class="spinner-border spinner-border-sm mr-1" role="status" v-if="item.marcacao.item_status.loading">
                          <span class="sr-only">Loading...</span>
                        </div>
                        <i class="fas fa-play mr-1" v-else></i>
                        Iniciar
                      </button>
                    </div>

                    <div class="text-center" v-if="item && item.marcacao 
                      && item.marcacao.dt_checkin && agora
                      && item.marcacao.dt_checkin.substr(0,10) == $util.hoje()">
                      <span v-if="te_max && te_max < duracao(item.marcacao.dt_checkin, false)" 
                        class="badge badge-danger">
                        Esperando {{ duracao(item.marcacao.dt_checkin) }}...
                      </span>
                      <span v-else class="small text-muted">
                        Esperando {{ duracao(item.marcacao.dt_checkin) }}...
                      </span>
                    </div>
                  </div>
                  <div v-else>
                    <span
                      v-if="1 == 0 && ( item.marcacao && item.marcacao.item_status.valor == 'chamado' )"
                      class="text-white"
                    >
                      <i :class="item.marcacao.item_status.icon"></i>
                      Chamado
                    </span>
                    <span
                      v-else-if="1 == 0 &&  ( item.marcacao && item.marcacao.item_status.valor == 'em atendimento' )"
                      class="text-nowrap text-truncate"
                    >
                      <i :class="item.marcacao.item_status.icon" class="mr-2"></i>
                      {{ item.marcacao.item_status.valor }}
                    </span>
                    <span
                      v-else-if="( item.marcacao && item.marcacao.atendimento && item.marcacao.atendimento.fl_editado_consultorio )"
                      class="text-nowrap text-truncate"
                    >
                      <i class="fas fa-pen mr-2"></i>
                      Editado
                    </span>
                    <etapas-atendimento :marcacao="item.marcacao" :iniciar="true" @click="iniciar">
                      <template v-slot:pos-etapas>
                        <!-- Posição -->
                        <div class="ml-2" v-if="nome == 'Atendido na Recepção' && agendas.length > 1 && ( id_fila_laudo_filtrado > 0 || tipo_proced == 'C' )"> <!-- && !search -->
                          <span class="badge badge-secondary">
                            {{ index + 1 }}
                          </span>
                        </div>
                      </template>
                    </etapas-atendimento>
                    <span v-if="item.marcacao">
                      <template v-if="item.marcacao && ( item.marcacao.item_status.valor == 'cancelado' )">
                        <i class="fa fa-ban text-danger mr-1" aria-hidden="true"></i>
                        Cancelado
                      </template>
                      <template v-else>
                        <div class="spinner-border spinner-border-sm mr-1" role="status" v-if="item.marcacao.item_status.loading">
                          <span class="sr-only">Loading...</span>
                        </div>
                        <i
                          class="fa fa-check mr-1"
                          v-else-if="item.marcacao.item_status.valor == 'finalizado'"
                        ></i>
                        <i class="far fa-clock mr-1" v-else></i>
                        {{ tempo(item.marcacao) }}
                      </template>
                    </span>
                  </div>
                </div>

                <!-- Hora da Marcação -->
                <div class="col col-12 col-md-2">
                    <div class="d-flex flex-column" v-if="item && item.marcacao && item.marcacao.autorizacao">
                        <a href="#" @click.prevent="ver_autorizacao (item.marcacao)" class="badge text-truncate" :class="'badge-' + item.marcacao.autorizacao.status_solicitacao.color">
                            {{ item.marcacao.autorizacao.status_solicitacao.msg }}
                        </a>
                    </div>
                    <div class="d-flex justify-content-center justify-content-md-start">
                        <celula-horarios-marcacao :hor="item" />
                    </div>
                </div>

                <!-- Identificação do Paciente -->
                <div class="col col-12 col-md-4">
                  <celula-dados-paciente 
                    :hor="item" 
                    v-if="item.marcacao" 
                    :callback_paciente="set_nome_search" 
                    :anexos="true"
                    @abriranexos="abrir_anexar_arquivo" />
                  <span v-if="!item.marcacao && item.status == 'bloqueado' && item.bloqueio">
                    {{ item.bloqueio.st_observacao }}
                  </span>
                </div>

                <!-- Identificação do Procedimento -->
                <div class="col col-12 col-md-4 d-flex justify-content-between" v-if="item.marcacao">
                  <celula-dados-procedimento 
                    :hor="item" 
                    @abriranexos="abrir_anexar_arquivo" 
                    @abrirpreatend="$refs.doc_pre_atend.abrir"
                    :total="lista.length"
                    :callback_filtrar="set_texto_search" />
                  <!-- Menu de opções -->
                  <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2"
                    v-if="item.status != 'livre' && item.marcacao.ch_estado_marcacao != 'C'">
                    <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <i class="fas fa-ellipsis-v"></i>
                    </a>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <template
                        v-if="item.marcacao
                          && item.marcacao.ch_estado_marcacao == 'A'
                          && !item.marcacao.id_atendimento
                          && item.marcacao.dt_inicio.substr(0,10) <= $util.hoje()">
                        <button class="dropdown-item" @click="registrar_checkin(item.marcacao)">
                          {{ item.marcacao.dt_checkin ? 'Remover Check-In' : 'Check-In' }}
                        </button>
                        <div class="dropdown-divider"></div>
                      </template>

                      <button
                        class="dropdown-item"
                        @click="cancelarAtendimento(item.marcacao)"
                      >{{ item.marcacao.id_atendimento ? 'Cancelar Atendimento' : 'Cancelar Marcação' }}</button>

                      <button
                        class="dropdown-item"
                        @click="remarcar(item.marcacao)"
                        :disabled="item.marcacao && item.marcacao.atendimento"
                      >Remarcar</button>

                      <button
                        class="dropdown-item"
                        @click="remarcar(item.marcacao, true)"
                        :disabled2="item.marcacao && item.marcacao.atendimento"
                      >Alterar Profissional</button>
                      
                      <button
                        v-if="$store.state.user.alter_unid && item.marcacao && item.marcacao.atendimento && item.marcacao.ch_estado_marcacao == 'A'"
                        class="dropdown-item"
                        @click="$refs.alterar_prof_solic.alterar(item.marcacao)"
                      >Alterar Profissional Solicitante</button>

                      <button
                        class="dropdown-item"
                        @click="$refs.alterar_proc.abrir(item)"
                        :disabled="item.marcacao && item.marcacao.ch_estado_marcacao != 'A'"
                      >Alterar Procedimento</button>
                      
                      <button
                        v-if="$store.state.user.alter_unid"
                        class="dropdown-item"
                        @click="$refs.alterar_unidade.abrir(item.marcacao)"
                        :disabled="item.marcacao && item.marcacao.ch_estado_marcacao != 'A'"
                      >Alterar Unidade</button>

                      <button
                        v-if="pode_alterar_data"
                        class="dropdown-item"
                        @click="$refs.alterar_data.abrir(item.marcacao)"
                        :disabled="item.marcacao && item.marcacao.id_atendimento && item.marcacao.ch_estado_marcacao != 'A'"
                      >Alterar Data</button>

                      <button
                        v-if="pode_alterar_data"
                        class="dropdown-item"
                        @click="alterar_data_entrega(item.marcacao)"
                        :disabled="item.marcacao && item.marcacao.id_atendimento && item.marcacao.ch_estado_marcacao != 'A'"
                      >Alterar Data de Entrega</button>

                      <button
                        v-if="$store.state.user.alter_unid && item.marcacao && item.marcacao.atendimento && item.marcacao.ch_estado_marcacao == 'A'"
                        class="dropdown-item"
                        @click="$refs.alterar_apoiado.alterar(item.marcacao)"
                      >Alterar Apoiado</button>

                      <button
                        class="dropdown-item"
                        @click="gerar_autorizacao(item.marcacao)"
                        v-if="$store.state.user.id_usuario == 1 && item.marcacao && !item.marcacao.atendimento && !item.marcacao.id_solicitacao_autorizacao">
                        Gerar Autorização
                      </button>

                      <button v-if="item.marcacao 
                                  && item.marcacao.atendimento 
                                  && ( 
                                    ( item.marcacao.atendimento.amostras && item.marcacao.atendimento.amostras.length ) 
                                    || item.marcacao.procedimento.id_especialidade == 2 
                                    || item.marcacao.procedimento.id_especialidade == 67 
                                  )"
                        class="dropdown-item" @click="$refs.amostras.abrir(item.marcacao.id_atendimento)">
                        Amostras
                      </button>

                      <button class="dropdown-item" 
                        v-if="item.marcacao && item.marcacao.atendimento && item.marcacao.st_id_externo && is_labs" 
                        @click="$refs.integra.abrir(item.marcacao)">
                        Verificar Integração
                      </button>

                      <button class="dropdown-item" 
                        v-if="item.marcacao && item.marcacao.atendimento && item.marcacao.st_id_externo && is_labs && item.marcacao.procedimento.id_classe_procedimento == 1 && item.marcacao.item_status.finalizado" 
                        @click="reintegrar_consulta_labs(item.marcacao)">
                        Re-Integrar Consulta
                      </button>

                      <button
                        v-if="$store.state.user.tem_adiantamentos && item.marcacao && item.marcacao.plano && item.marcacao.plano.id_operadora == 1"
                        class="dropdown-item" @click="abrir_pagamentos(item.marcacao)">
                        Pagamentos
                      </button>

                      <div class="dropdown-divider"></div>

                      <button
                        class="dropdown-item"
                        @click="abrir_anexar_arquivo(item.marcacao)"
                        :disabled="!item.marcacao">
                        Anexar Arquivo
                        <span class="badge badge-secondary" v-if="item.marcacao.arquivos && item.marcacao.arquivos.length">
                          {{ item.marcacao.arquivos.length }}
                        </span>
                      </button>
                      <button class="dropdown-item" @click="importar_externo(item.marcacao)" v-if="item.marcacao && $store.state.user.id_usuario == 1">
                        Resultados de Exames
                      </button>
                      <button
                        class="dropdown-item"
                        @click="ver_arquivos_aut(item.marcacao)"
                        v-if="item.marcacao.id_solicitacao_autorizacao">
                        Arquivos da Autorização
                      </button>
                      <button
                        class="dropdown-item"
                        @click="$refs.doc_pre_atend.abrir(item.marcacao)"
                        :disabled="!item.marcacao">
                        Pré-Atendimento
                        <span class="badge badge-secondary" v-if="item.marcacao.doc_pre_atends_count || ( item.marcacao.doc_pre_atends && item.marcacao.doc_pre_atends.length )">
                          {{ item.marcacao.doc_pre_atends_count 
                              ? item.marcacao.doc_pre_atends_count
                              : item.marcacao.doc_pre_atends.length }}
                        </span>
                      </button>
                      <span
                        class="d-inline-block w-100"
                        tabindex="0"
                        data-toggle="tooltip"
                        title="Paciente não atendido"
                        v-if="item.marcacao.atendimento == null"
                      >
                        <button class="dropdown-item" @click="printAtestado(item.marcacao)" disabled>Emitir Atestado</button>
                      </span>
                      <template v-else>
                        <button class="dropdown-item" @click="printAtestado(item.marcacao)">Emitir Atestado</button>
                      </template>
                      <button class="dropdown-item" @click="printEtiqueta(item.marcacao)">Emitir Etiqueta</button>
                      <template v-if="item.marcacao">
                        <button class="dropdown-item" @click="novoDocumento(item.marcacao)">Emitir Documento</button>
                      </template>
                      <template v-if="item.marcacao && tem_recepcoes && referencia.substr(0,10) == $util.hoje()">
                        <button class="dropdown-item" @click="encaminhar_recepcao(item.marcacao)">Encaminhar para Outra Recepção</button>
                      </template>
                      <template v-if="item.marcacao && item.marcacao.atendimento && item.marcacao.atendimento.amostras && item.marcacao.atendimento.amostras.length">
                        <button class="dropdown-item" @click="verificarResultadoExterno(item.marcacao)">Verificar Resultado</button>
                      </template>
                      <template v-if="item.marcacao.dt_inicio.substr(0,10) == $util.hoje()">
                        <div class="dropdown-divider"></div>
                        <button class="dropdown-item"
                          @click="chamar_para_recepcao(item.marcacao)" >
                          Chamar Paciente
                        </button>
                        <button class="dropdown-item" v-if="nome == 'Pausados'" @click="despausar(item.marcacao)" >
                          Liberar Paciente para ser Chamado
                        </button>
                        <button class="dropdown-item" v-if="item.marcacao && item.marcacao.procedimento && item.marcacao.procedimento.id_especialidade == 2 && nome == 'Atendido na Recepção'" @click="finalizar(item.marcacao)" >
                          Finalizar Atendimento
                        </button>
                        <!--
                        <button class="dropdown-item"  @click="abrir_modal_ocerizacao()" v-if="$store.state.user.id_usuario == 1">
                          Ocerizar
                        </button>
                        -->
                      </template>
                      <!-- <a class="dropdown-item" href="#">Emitir Atestado</a> -->
                    </div>
                  </div>

                  <!-- Reativar Cancelado -->
                  <div
                    class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2"
                    v-if="item.status != 'livre' && item.marcacao.ch_estado_marcacao == 'C' && item.marcacao.id_atendimento && usuario_cancela_atend_prof"
                  >
                    <a
                      href="#"
                      role="button"
                      id="dropdownMenuLink"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </a>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <button class="dropdown-item" @click="reativarAtendimento(item.marcacao)">
                        Reativar Atendimento
                      </button>
                    </div>
                  </div>
                </div>
              </div>  
              <div class="row p-0">
                <div class="col col-12" v-if="item.marcacao && item.marcacao.paciente && item.marcacao.paciente.atendimento_pacotes && item.marcacao.paciente.atendimento_pacotes.length">
                    <historico-pacotes-paciente 
                        autoriz2="true"
                        :id_atendimento="item.marcacao.id_atendimento"
                        :id_procedimento="item.marcacao.id_procedimento"
                        :lista="item.marcacao.paciente.atendimento_pacotes" 
                        :ativos="true"
                        :reduzido="true" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="tabela_checkin && tabela_checkin.lista">
          <table class="table table-sm table-hover bg-white">
            <thead>
              <tr>
                <td>Profissional</td>
                <td class="text-center" v-for="(status_ck, icx) in tabela_checkin.lista_status" :key="icx">
                  {{ status_ck }}
                </td>
              </tr>
            </thead>
            <tbody>
              <template v-for="(lista_itens, profissional, idx) in tabela_checkin.lista">
                <tr :key="idx" v-if="lista_itens['CheckIn'] > 0">
                  <td>
                    <a href="#" @click.prevent="set_nome_search(profissional)" class="card-link">
                      {{ profissional }}
                    </a>
                  </td>
                  <td class="text-center" v-for="(status_ck, icx) in tabela_checkin.lista_status" :key="icx">
                    <span v-if="lista_itens[status_ck]">{{ lista_itens[status_ck] }}</span>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>

      <div v-else>
        <az-empty-state
          :feriado="feriado"
          :bloqueio="bloqueio"
          :msg="
            lista === null
              ? 'Clique aqui para buscar.'
              : (
                ( search || ( faixa_hora != 'D' && filtrar_faixa_hora ) )
                  ? 'Nenhum paciente encontrado.'
                  : ( viewMode == 'B' 
                      ? 'Nenhum paciente bloqueado nessa data.'
                      : 'Nenhum paciente marcado para essa data.' )
              )
          "
          :icon="( lista === null || this.search )
            ? 'fas fa-sync-alt' 
            : ( search ? 'fas fa-search' : ( viewMode == 'B' ? 'fa fa-ban' : 'fas fa-user-clock' ) )"
          :action="( lista === null || this.search ) ? 'Buscar' : ''"
          :method="load"
        ></az-empty-state>

      </div>
    </div>

    <!--
    <div class="alert alert-info mt-3">
      <pre>{{ lista }}</pre>
    </div>
    -->

    <!-- Modal -->
    <div class="modal fade" id="painelModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Painel de Chamadas</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <label class="form-control">{{ link_painel }}</label>

            <div class="d-flex flex-column">
              <a :href="link_painel" class="btn btn-outline-primary mb-2" target="_blank">
                <i class="fa fa-play mr-2" aria-hidden="true"></i>
                Abrir
              </a>
              <button type="button" class="btn btn-outline-primary" @click="copiar_clipboard(link_painel)">
                <i class="fas fa-copy mr-2"></i>
                Copiar
              </button>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Novo Atendimento -->

    <div class="modal fade" id="novoAtendimento2Modal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-total modal-dialog22 modal-dialog-scrollable" role="document">
        <div class="modal-content modal-content-total modal-content22">
          <div class="modal-header">
            <span>Novo Atendimento</span>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <Marcacao
              ref="marcacao"
              origem="recep"
              :data="referencia"
              :hora="refHora"
              :hg="refHg"
              :id_unidade_operacao="refUnidOper"
              :id_recepcao="unidade_operacao ? $util.getCookie('id_recepcao') : null"
              modalName="novoAtendimento2Modal"
              :tem_atend_outro="tem_atend_outro"
              @refresh="concluir_marcacao"
            ></Marcacao>
          </div>
        </div>
      </div>
    </div>
    <!-- Fim Modal de Novo Atendimento -->

    <!-- Emitir Atestado -->
    <PrintAtestado ref="atestado" />

    <!-- Cancelar Marcação -->
    <CancelarMarcacao ref="canc_atd" @cancelado="load(false)" />

    <!-- Iniciar Atendimento -->
    <IniciarAtendimento 
        ref="ini_atd" 
        :altera_prof="$refs.alterar_prof"
        @refresh="load(false)" 
        @novo="novoAtendimento" 
        @encaminhar="encaminhar_recepcao"
        @atualizar_progresso="atualizar_progresso" />

    <!-- Alterar Procedimento -->
    <alterar-procedimento ref="alterar_proc" @refresh="load(false)" />

    <!-- Alterar Unidade -->
    <alterar-unidade ref="alterar_unidade" @refresh="load(false)" />

    <!-- Alterar Data -->
    <alterar-data ref="alterar_data" @refresh="load(false)" />

    <!-- Alterar Profissional -->
    <alterar-profissional ref="alterar_prof" @refresh="load(false)" />

    <!-- Alterar Profissional -->
    <alterar-profissional-solicitante ref="alterar_prof_solic" @refresh="load(false)" />

    <!-- Alterar Apoiado -->
    <alterar-apoiado ref="alterar_apoiado" @refresh="load(false)" />

    <!-- Pré Atendimento -->
    <documento-pre-atendimento ref="doc_pre_atend" />

    <!-- Documentos -->
    <documento ref="documento" :recepcao="true" refresh="imprimir_documento" />

    <!-- Laboratório -->
    <amostras ref="amostras" />
    <validar-integracao ref="integra" @refresh="load(false)" />   

    <!-- Emitir Etiqueta -->
    <emitir-etiqueta ref="etiqueta" />

    <!-- Alterar Prazo de Entrega -->
    <laudos-prazo-entrega ref="prazo_entrega" @refresh="load(false)" />

    <template v-if="1 == 0">
      <button type="button" class="btn btn-primary my-3" @click="teste_notificar ()">Teste</button>
      <pre>{{ marcacoes }}</pre>
    </template>

    <!-- Envio de Arquivo -->
    <template v-if="acao_anexar">
      <az-file-upload
        ref="upload"
        @refresh="carregar_arquivos()"
        :multiple="true"
        :arquivos="marcacao.arquivos"
        :parms="{ 
          model_type: marcacao.id_marcacao ? 'marcacao' : ( marcacao.id_cadastro_temporario ? 'cadastroTemporario' : 'pessoa' ), 
          model_id: marcacao.id_marcacao ? marcacao.id_marcacao : ( marcacao.id_cadastro_temporario ? marcacao.id_cadastro_temporario : marcacao.id_pessoa ), 
          id_paciente: marcacao.id_paciente ? marcacao.id_paciente : marcacao.id_pessoa,
          tipo_especial: marcacao.id_marcacao ? null : 'anexo', 
        }" />
    </template>

    <template v-if="acao_anexar_aut && marcacao.autorizacao && marcacao.autorizacao.arquivos">
      <az-file-upload
        ref="upload_aut"
        :multiple="true"
        :arquivos="marcacao.autorizacao.arquivos"
        :parms="{ model_type: 'solicitacaoAutorizacao', model_id: marcacao.id_solicitacao_autorizacao, id_paciente: marcacao.id_paciente }" />
    </template>

    <!-- Instruções por Médico -->
    <div v-if="instrucoes">
      <hr>
      <agenda-do-medico :dados="agenda_do_medico" :referencia="referencia" />

      <div class="card dashcard mt-3" v-for="(inst, idx) in instrucoes" :key="idx">
        <div class="card-header">
          Instruções para {{ inst.title }}
        </div>
        <div class="card-body">
          <span v-html="inst.text"></span>
        </div>
      </div>
    </div>

    <template v-if="1 == 1 || $store.state.user.id_usuario == 1">
      <hr>

      <div class="text-center">
        <a href="#" class="card-link" @click.prevent="tour()">
          <i class="far fa-compass fa-2x"></i>
        </a>
      </div>
    </template>

    <br><br><br><br><br>

    <!-- Modal Encaminhar para Outra Recepção -->
    <div class="modal fade" id="encaminharRecepModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="marcacao && recepcoes_destino && recepcoes_destino.length">
          <div class="modal-header">
            <h5 class="modal-title">Encaminhar para Outra Recepção</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <div class="card">
              <div class="card-body">
                <celula-dados-paciente :hor="{ marcacao: marcacao }" />
              </div>
            </div>

            <ul class="list-group mb-3">
              <li class="list-group-item" :class="marcenc.selec ? 'active' : ''"
                v-for="(marcenc, imx) in lista_outras_marcacoes" :key="imx">
                <input type="checkbox" class="mr-2" :disabled="$store.state.loading || marcenc.id_marcacao == marcacao.id_marcacao"
                  v-model="marcenc.selec">
                {{ marcenc.procedimento.search }}
                <div class="small ml-4">{{ marcenc.medico.st_nome_exibicao }}</div>
              </li>
            </ul>

            <p class="text-primary mb-0">Selecione a recepção de destino:</p>
            <div class="progress my-1">
              <div class="indeterminate" v-if="$store.state.loading"></div>
              <div class="determinate" v-else></div>
            </div>

            <div class="list-group">
              <button type="button" class="list-group-item list-group-item-action"
                v-for="(recepd, irx) in recepcoes_destino" :key="irx"
                :disabled="$store.state.loading"
                @click="save_encaminhar_recepcao(recepd)">
                <i class="fas fa-concierge-bell mr-2"></i>
                {{ recepd.search }}
              </button>
            </div>

            <pre v-if="false">{{ marcacao }}</pre>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Paginação -->
    <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="paginacao && paginacao.last_page > 1">
      <div class="d-flex">
        <paginate
            class="mb-0"
            :page-count="paginacao.last_page"
            :container-class="'pagination'"
            :page-class="'page-item'"
            :page-link-class="'page-link'"
            :prev-class="'page-link'"
            :next-class="'page-link'"
            :prev-text="'<<'"
            :next-text="'>>'"
            :click-handler="paginar">
        </paginate>
      </div>
    </nav>

    <lista-atend-outros ref="atendoutros" :recepcao="true" @refresh="load(false)" @verColeta="verColeta" />
    <check-in ref="chk" :recepcao="true" @refresh="load(false)" />
    <importar-externo ref="import" />
    <az-ocerizator ref="ocerizacao"/>  
    <selecao-medico-lista ref="selmed" @selecionados="filtrar_selecao_medicos" />
    <ver-fila-consultorio ref="fila_consultorio" />
    <ver-autorizacao ref="ver_autorizacao" />

  </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
import * as moment from "moment";
import CancelarMarcacao from "../callcenter/CancelarMarcacao.vue";
import Marcacao from "../callcenter/Marcacao.vue";
import IniciarAtendimento from "./IniciarAtendimento.vue";
import EtapasAtendimento from "./EtapasAtendimento.vue";
import PrintAtestado from "../../shared/atestado/FormAtestado";
import { setInterval } from "timers";
import AzBreakTitle from "../../util/AzBreakTitle.vue";
import AlterarProcedimento from './AlterarProcedimento.vue';
import AlterarUnidade from './AlterarUnidade.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';
import DocumentoPreAtendimento from '../../shared/DocumentoPreAtendimento.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

import CelulaHorariosMarcacao from "../../shared/table/CelulaHorariosMarcacao.vue";
import CelulaDadosPaciente from "../../shared/table/CelulaDadosPaciente.vue";
import CelulaDadosProcedimento from "../../shared/table/CelulaDadosProcedimento.vue";

import { subscribe } from "../../../service/Notify";
import EventBus from '../../../service/EventBus';

import AlterarProfissional from './AlterarProfissional.vue';
import EmitirEtiqueta from '../../shared/EmitirEtiqueta.vue';
import AlterarProfissionalSolicitante from './AlterarProfissionalSolicitante.vue';
import AlterarApoiado from './AlterarApoiado.vue';
import AlterarData from './AlterarData.vue';

import Documento from '../consultorio/Documento.vue';
import Amostras from '../laboratorio/Amostras.vue';

import AgendaDoMedico from '../callcenter/AgendaDoMedico.vue';
import ListaAtendOutros from './ListaAtendOutros.vue';
import CheckIn from './CheckIn.vue';
import ValidarIntegracao from '../reembolso/ValidarIntegracao.vue';

import ImportarExterno from '../consultorio/ImportarExterno.vue';
import OutrosChamada from '../../shared/OutrosChamada.vue';
import AzOcerizator from "../../util/AzOcerizator.vue";

import SelecaoMedicoLista from '../callcenter/SelecaoMedicoLista.vue';
import HistoricoPacotesPaciente from '../../shared/HistoricoPacotesPaciente.vue';

import VerFilaConsultorio from '../consultorio/VerFilaConsultorio.vue';
import LaudosPrazoEntrega from '../laudos/LaudosPrazoEntrega.vue';
import VerAutorizacao from './VerAutorizacao.vue';


export default {
  data() {
    return {
      refHora: "",
      refHg: "", 
      marcacoes: null,
      lista: null, //{ agendas: {} },
      medicos: [],
      unidade_operacao: "",
      medico: "",
      procurar: "",
      input: "",
      marcacao: null,
      firstLoad: false,
      agora: "",
      tmaInterval: null,
      search: "",
      viewMode: "A",
      feriado: null,
      bloqueio: null,
      referencia: this.$util.hoje(),
      viewStatus: 0,
      viewEspec: "",
      local: "",
      refUnidOper: "",
      acao_anexar: false,
      faixa_hora: 'D',
      instrucoes: null,
      montando: true,
      pagamentos: null,
      canceltoken: null,
      page: 1,
      paginacao: null,
      tem_paginacao: false,
      agenda_do_medico: null,
      outros: null,
      tem_atend_outro: null,
      tem_recep_fila_proc: null,
      filas_proc: [],  
      id_fila_laudo: "", 
      id_fila_laudo_filtrado: null, 
      tipo_proced: "T", 
      tem_recepcoes: false,
      recepcoes_destino: [],
      lista_outras_marcacoes: [],
      lista_filtros_exibicao: [
        {
          ordem: 0,
          quebra: "Todos",
          icon: "fas fa-users"
        }
      ], 
      editados: null, 
      apenas_editados: false, 
      acao_anexar_aut: false,
      te_max: "",  
      retracao: [], 
      medicos_selecionados: [],  
      filtro_lista_medicos: [], 
      pode_atend_futuro: false, 
      pode_alterar_data: false, 
      conf_exibir_pacotes: false, 
      block_view_pacotes: false, 
      filtro_teleatend: false, 
      turno: 'G', 
      tabela_checkin: null, 
    };
  },
  watch: {
    '$store.state.unidade': function () {
      this.load();
    }
  },

  computed: {
    is_labs: function () { 
      return window.redir == 'labs' || window.redir == 'teste';
    },

    usuario_cancela_atend_prof: function () {
      return this.$store.state.user.id_usuario == 1 || this.$store.state.user.permissao_usuarios.find(item => item.id_acao == 7) ? true : false;
    },

    lista_medicos: function () {
      if ( !this.viewEspec || !this.medicos ) {
        return this.medicos ? this.medicos.filter(item => !item.fl_block_atend) : [];
      }

      return this.medicos.filter(item => !item.fl_block_atend)
        .filter(
          item => item.medico_especialidade.findIndex(
            esp => esp.id_especialidade == this.viewEspec
          ) >= 0
        );
    },

    lista_especialidades: function() {
      if ( !this.lista || !this.lista.length )
        return [];

      let opcoes = _.uniqBy(this.lista.filter(item => item.marcacao),
        (item) => {
          return item.marcacao.procedimento.id_especialidade;
        })
        .map((item) => {
          return {
            ordem: item.marcacao.procedimento.especialidade.st_especialidade,
            id: item.marcacao.procedimento.id_especialidade,
            quebra: item.marcacao.procedimento.especialidade.st_especialidade,
            dados: item.marcacao.procedimento.especialidade,
            icon: '',
          }
        });

      if ( opcoes.length > 0 ) {
        //opcoes.push(todos);
        opcoes = _.sortBy(opcoes, item => item.ordem);
      } else {
        opcoes = [];
      }

      return opcoes;

    },

    filtrar_faixa_hora: function () {
      return !this.medico && this.referencia == this.$util.hoje();
    },
    link_painel: function () {
      if ( this.$store.state.unidade.unidade_operacaos.length == 1 ) {
        return this.$store.state.unidade.unidade_operacaos[0].link_painel;
      } else if ( this.unidade_operacao ) {
        let unid = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.unidade_operacao);

        if ( unid )
          return unid.link_painel;
      }

      return null;
    },
    referencia2: {
      get() {
        return this.$store.state.referencia;
      },
      set(value) {
        this.$store.commit("setReferencia", value);
      }
    },
    lista_filtros: function () {
      let todos = {
          ordem: 0,
          quebra: "Todos",
          icon: "fas fa-users"
        };

      if ( !this.lista || !this.lista.length )
        return [todos];

      let opcoes = _.uniqBy(this.lista.filter(item => item.marcacao),
        (item) => {
          return item.marcacao ? item.marcacao.item_status.quebra : {};
        })
        .map(item => item.marcacao.item_status );

      if ( opcoes.length >= 1 ) {
        opcoes.push(todos);
        opcoes = _.sortBy(opcoes, item => item.ordem);
      } else {
        opcoes = [todos];
      }

      return opcoes;
    },
    campo_unidade: function () {
      if ( this.$store.state.unidade.unidade_operacaos.length > 1 && this.$store.state.user && !this.$store.state.user.id_unidade_operacao )
        return true;
      else
        return false;
    },
    exibicao: function() {
      if (!this.lista || !this.lista.length) return;

      // Ordenar e Filtrar
      var novaLista;

      novaLista = this.lista.filter(item => this.turno == 'G'
        || ( this.turno == 'M' && item.hora < '13:00') 
        || ( this.turno == 'V' && item.hora >= '13:00' && item.hora < '19:00') 
        || ( this.turno == 'N' && item.hora >= '19:00') 
      );

      if ( this.viewStatus || this.viewMode == "A" ) { 

        novaLista = novaLista.filter(item => ( item.status != "livre" && item.status != "bloqueado" ) 
          && (
            !this.viewStatus || item.marcacao.item_status.ordem == this.viewStatus
            || ( this.viewStatus == 'RP'  && item.marcacao.fl_particular && item.marcacao.id_atendimento && item.marcacao.item_status.ultima_etapa.id_etapa_atendimento == 2 )
          )
          && ( !this.viewEspec || this.lista_especialidades.length <= 1 || item.marcacao.procedimento.id_especialidade == this.viewEspec )
        );

      }
      
      if (this.viewMode == "A") {
        novaLista = _.sortBy(novaLista, item => item.marcacao.item_status.ordem);

        return _.groupBy(novaLista, (item) => {
          return item.marcacao.item_status.quebra;
        });
      } else {
        novaLista = _.orderBy(novaLista, "medico.st_nome_exibicao", "asc");
        return _.groupBy(novaLista, function(item) {
          return item.medico ? item.medico.st_nome_exibicao : 'Agenda';
        });
      }
    },
    isMedicoSelected: function() {
      var idMedico = this.medico;
      var index = _.findIndex(this.medicos, function(item) {
        return idMedico == item.id_pessoa;
      });
      index = parseInt(index);
      if (index != -1) {
        return this.medicos[index].st_nome_exibicao;
      }
      return "";
    },
  },
  methods: {
    ver_autorizacao (marcacao) { 
        this.$refs.ver_autorizacao.abrir(marcacao);
    },

    alterar_data_entrega (marcacao) { 
        this.$refs.prazo_entrega.abrir_marcacao(marcacao.id_marcacao);
    },

    ver_fila_medico (id_medico) { 
        this.$refs.fila_consultorio.abrir(id_medico, this.referencia);
    }, 

    filtrar_medico (lista) { 
        let id_medico = _.get(lista, '0.medico.id_pessoa');
        this.medico = ( this.medico == id_medico ? null : id_medico );
        this.trocar_view_mode(this.medico ? 'A' : 'G');

        //this.load(false);
    },

    verColeta (item) { 
      this.$refs.amostras.abrir(item.id_atendimento, false, "", item.id_atendimento_outro);
    },

    filtrar_selecao_medicos (lista_selec) { 
      let lista = lista_selec.map(item => item.id_pessoa);

      if ( lista.length == 1 ) { 
        this.filtro_lista_medicos = [];
        this.medico = lista[0];  
      } else { 
        if ( !lista.length && this.status == 'H' && !this.hor_livre_todos ) { 
          this.status = 'A';
          this.lista = [];
        }

        this.filtro_lista_medicos = lista;
      }

      this.$util.setCookie('rlm', JSON.stringify(this.filtro_lista_medicos));

      this.load(false);
    },

    selecionar_medicos () { 
      $('[data-toggle="tooltip"]').tooltip("dispose");
      this.$refs.selmed.abrir_por_unidade(this.unidade_operacao, this.filtro_lista_medicos);
      // this.$refs.selmed.abrir(this.lista_medicos, this.filtro_lista_medicos);
    },

    toggle_retracao(iq) { 
      this.retracao[iq] = this.retracao[iq] ? false : true;

      if ( iq == 'Pacientes Atendidos' ) { 
        this.$util.setCookie('RCP-' + iq, this.retracao[iq] ? 1 : 0, 365);
      }
      
      this.$forceUpdate();
    },

    duracao (data, humanize = true) { 
      return humanize
          ? moment
              .duration(moment(data, "YYYY-MM-DD HH:mm:ss").diff(this.$util.hoje() + ' ' + this.agora))
              .humanize(true)
          : moment
              .duration(moment(this.$util.hoje() + ' ' + this.agora, "YYYY-MM-DD HH:mm:ss").diff(data))
              .asMinutes();
    },

    reintegrar_consulta_labs (marcacao) { 
      this.$util.atualizar(this, { 
        service: 'terceiros',
        func: 'reintegrar_consulta_labs',
        dados: { 
          id_atendimento: marcacao.id_atendimento,
        }
      });
    },
    
    importar_externo (marcacao) { 
      this.$refs.import.abrir(marcacao);
    },

    finalizar (marcacao) { 
      if ( !confirm('Confirma finalizar o atendimento do paciente?') ) 
        return;

      this.$util.atualizar(this, { 
        service: 'atendimentos',
        func: 'finalizar',
        dados: { 
          id: marcacao.id_atendimento,
          force: true, 
        },
        toast: true, 
        reload: true, 
      });  
    },

    despausar (marcacao) { 

      if ( !confirm('Confirma liberar o paciente para ser chamado novamente no consultório?') ) 
        return;

      this.$util.atualizar(this, { 
        service: 'atendimentos',
        func: 'pausar',
        dados: { 
          id: marcacao.id_atendimento,
          despausar: true, 
        },
        toast: true, 
      });

    },

    ver_arquivos_aut (marcacao) { 
      this.marcacao = _.cloneDeep(marcacao);

      this.$util.load(this, { 
        service: 'solicitacao_autorizacoes',
        func: 'show', 
        parms: { 
          id: marcacao.id_solicitacao_autorizacao, 
          para_arquivos: true, 
        },
        loadTo: res => { 
          this.marcacao.autorizacao = { 
            arquivos: res.arquivos,
          };
          this.acao_anexar_aut = true; 

          this.$nextTick(() => {
            this.$refs.upload_aut.abrir();
          });
        }
      });
    },

    buscar_editados () { 
      this.apenas_editados = !this.apenas_editados;
      this.load(false);
    },

    alterar_tipo_proced () { 
      this.$nextTick(() => { 
        this.load();
      });
    },

    atualizar_progresso (item, deep = 0) { 
      if ( item.pa.id_atendimento ) { 
        let marcacao = this.marcacoes.find(marcacao => marcacao.marcacao && marcacao.marcacao.id_atendimento == item.pa.id_atendimento);

        if ( marcacao ) { 
          let pa = marcacao.marcacao.atendimento.progresso_atendimentos.find(prog => prog.id_progresso_atendimento == item.pa.id_progresso_atendimento);

          if ( pa && item.pa.dt_conclusao ) { 
            pa.dt_conclusao = item.pa.dt_conclusao;
          }

          if ( item.item_status && marcacao.marcacao && marcacao.marcacao.item_status ) { 
            marcacao.marcacao.item_status = item.item_status;
          }
        }

        if ( item.outros && !deep ) { 
          item.outros.forEach(outro => { 
            this.atualizar_progresso(outro, 1);
          });
        }
      }
    },

    trocar_view_mode(mode) { 
      this.viewMode = mode;
      this.load(false);

      /*
      if ( mode == 'B' ) { 
        this.viewMode = 'B';
        this.load(false);
      } else if ( this.viewMode == 'B' ) { 
        this.viewMode = mode;
        this.load(false);
      } else { 
        this.viewMode = mode;
      }
      */
    },

    registrar_checkin(marcacao) {
      if ( marcacao.dt_checkin ) {
        this.$refs.chk.remover_checkin(marcacao);
      } else {
        this.$refs.chk.realizar_check_in(marcacao);
      }
    },

    abrir_pagamentos(marcacao) {
      if ( !marcacao )
        return;

      if ( !marcacao.id_paciente ) { 
        this.$router.push({ path: '/recepcao/pagamentos/' + ( marcacao.id_cadastro_temporario ? 'p' + marcacao.id_cadastro_temporario : '' ) });
      } else { 
        this.$router.push({ path: '/recepcao/pagamentos/' + ( marcacao.id_paciente ? marcacao.id_paciente : '' ) });
      }

    },

    save_encaminhar_recepcao (recepcao) {
      this.$util.atualizar(this, {
        service: 'marcacoes',
        func: 'encaminhar_recepcao',
        dados: {
          ids: this.lista_outras_marcacoes.filter(marcacao => marcacao.selec)
            .map(item => item.id_marcacao ),
          id_recepcao: recepcao.id_recepcao,
        },
        modal: 'encaminharRecepModal',
        toast: true,
        callback: () => {
          this.load(false);
        }
      })
    },

    encaminhar_recepcao (marcacao) {
      $('.modal').modal('hide');

      if ( marcacao && !marcacao.id_unidade_operacao ) {
        marcacao = this.lista.find(item => item.marcacao && item.marcacao.id_marcacao == marcacao.id_marcacao);

        if ( marcacao ) {
          marcacao = marcacao.marcacao;
        }
      }

      if ( !marcacao )
        return;

      this.marcacao = marcacao;

      let uo = this.$util.unidade_operacao();

      if ( !uo || uo.id_unidade_operacao != marcacao.id_unidade_operacao ) {
        this.$toast.add({
          severity: "error",
          summary: "Encaminhar",
          detail: 'Unidade inválida.',
          life: 5000
        });
        return;
      }

      this.lista_outras_marcacoes = [];

      if ( this.lista ) {
        let base;
        //let recep = this.$util.recepcao();

        if ( this.marcacao.id_cadastro_temporario ) {
          base = this.lista.filter(item => item.marcacao && item.marcacao.ch_estado_marcacao == 'A' && item.marcacao.id_cadastro_temporario == this.marcacao.id_cadastro_temporario);
        } else {
          base = this.lista.filter(item => item.marcacao && item.marcacao.ch_estado_marcacao == 'A' && item.marcacao.id_paciente == this.marcacao.id_paciente);
        }

        base = _.cloneDeep(base);

        this.lista_outras_marcacoes = base.map(item => {
          item.marcacao.selec = ( item.marcacao.id_marcacao == this.marcacao.id_marcacao );
          return item.marcacao;
        });

      }

      this.recepcoes_destino = uo.recepcaos.filter(recep => !marcacao.id_recepcao || recep.id_recepcao != marcacao.id_recepcao);

      $('#encaminharRecepModal').modal('show');
    },

    abrir_atend_outros (lista) {
      this.$refs.atendoutros.abrir(lista);
    },

    gerar_autorizacao(marcacao) {
      if ( !confirm('Confirma gerar a autorização?') )
        return;

      this.$util.atualizar(this, {
        service: 'solicitacao_autorizacoes',
        func: 'gerar_autorizacao_da_marcacao',
        dados: {
          id_marcacao: marcacao.id_marcacao,
        },
        toast: true,
        callback: solic => {
          marcacao.id_solicitacao_autorizacao = solic.id_solicitacao_autorizacao;
        }
      });
    },

    ativar_rebuscar() {
      this.lista = null;
    },

    verificarResultadoExterno(marcacao) {
      this.$util.atualizar(this, {
        service: 'laudos',
        func: 'buscar_resultado_externo',
        redir_api: true, 
        dados: {
          id_marcacao: marcacao.id_marcacao,
        },
        toast: true,
      });
    },

    novoDocumento(marcacao) {
      this.$refs.documento.novoDocumento(marcacao);
    },

    printEtiqueta (marcacao) {
      this.$refs.etiqueta.emitir('marcacao', marcacao);
    },

    beep() {
      const el = document.getElementById("beepElementId");
      el.play();
    },

    reativarAtendimento(marcacao) {
      this.$util.atualizar(this, {
        service: 'agendas',
        func: 'reativar',
        dados: {
          id: marcacao.id_marcacao,
        },
        reload: true,
        toast: true,
      });
    },

    set_nome_search(search) {
      if ( this.search == search )
        this.search = "";
      else
        this.search = search;

      this.pesquisar();
    },

    set_texto_search(search) {
      if ( this.search == '"' + search + '"' )
        this.search = "";
      else
        this.search = '"' + search + '"';

      this.pesquisar();
    },

    filtrar_status(status) {
      this.viewStatus = status;

      if ( ( this.tem_paginacao || ( this.faixa_hora && this.faixa_hora != 'D' ) ) && !this.medico ) {
        this.page = 1;
        this.load(false);
      }
    },

    concluir_marcacao (item) {
      //console.log('Marcado!', item);
      this.load(false);

      if ( item && this.referencia.substr(0,10) == this.$util.hoje() ) {
        this.iniciar(item);
      }
    },

    paginar (page) {
      this.page = page;
      this.load(false);
    },

    tour() {
      window.scrollTo(0,0);

      // Define the tour!
      var tour = {
        id: "hello-hopscotch",
        i18n: {
                doneBtn: "Pronto",
                nextBtn: "Próximo",
                prevBtn: "Anterior",
                skipBtn: "Pular"
            },
        steps: [
          {
            title: "Atualizar Informações",
            content: "Clicando nesse botão, os dados da tela são atualizados.",
            target: "refresh-button",
            placement: "right"
          },
          {
            title: "Data do Atendimento",
            content: "Indica a data de atendimento desejada. Serão exibidos os agendamentos e atendimentos para a data selecionada.",
            target: "ref-data",
            placement: "bottom"
          },
          {
            title: "Especialidade / Médico",
            content: "Selecione a especialidade e/ou médico para filtrar os itens relacionados. Quando é selecionado um médico específico, é possível consultar sua agenda a partir da opção 'Livres', além de visualizar eventuais instruções cadastradas para ele.",
            target: "filtro-medico",
            placement: "bottom"
          },
          {
            title: "Pesquisar",
            content: "Realizar uma pesquisa a partir de um texto livre, como nome do paciente, médico ou operadora.",
            target: "filtro-pesquisar",
            placement: "left"
          },
          {
            title: "Novo Atendimento",
            content: "Botão para inclusão de um novo atendimento, que não tenha um agendamento prévio.",
            target: "novo-atendimento",
            placement: "left"
          },
          {
            title: "Filtro por Status",
            content: "Possibilidade de filtrar os lançamentos pelo status do atendimento.",
            target: "filtro-status",
            placement: "bottom"
          },
          {
            title: "Filtro por Intervalo",
            content: "Nessa opção, é possível escolher visualizar todos os lançamentos da data, ou somente de um faixa de horário, (1h, 2h ou 4h). Quando é selecionada uma faixa de horário, são exibidos apenas os lançamentos em atendimento e os agendamentos contidos no intervalo da faixa de horário selecionada.",
            target: "filtro-horario",
            placement: "left"
          },
          {
            title: "Etapas do Atendimento",
            content: "Exibe as etapas do atendimento na recepção realizadas (cadastro do paciente, relação de procedimentos e guias ou pagamentos gerados), e a duração de atendimento do paciente.",
            target: "etapas-atendimento",
            placement: "right"
          }

        ]
      };

      window.hopscotch.startTour(tour);
    },
    selecionar_faixa_hora() {
      this.$util.setCookie('recep-faixa-hora', this.faixa_hora);
      this.load(false);
    },

    abrir_anexar_arquivo(marcacao) {
      this.marcacao = marcacao;
      this.acao_anexar = true;

      // Ajuste para carregar os arquivos sempre que clicar no botão
      this.carregar_arquivos(true);
      return;

      // if ( this.marcacao.arquivos && this.marcacao.arquivos.length && !this.marcacao.arquivos.find(arq => arq.arquivo) ) {
      //   this.carregar_arquivos(true);
      //   return;
      // }

      // this.$nextTick(() => {
      //   this.$refs.upload.abrir();
      // });
    },

    carregar_arquivos (abrir = false) {

      this.$store.commit('loading', true);

      if ( this.marcacao.id_marcacao ) { 

        this.$util.loadItem(this, {
          service: 'arquivos',
          func: 'links',
          parms: {
            id: this.marcacao.id_marcacao,
            type: 'marcacao',
          }
        })
        .then(res => {
          this.marcacao.arquivos = res;

          if ( abrir ) {
            this.$nextTick(() => {
              this.$refs.upload.abrir();
            });
          }
        })
        .finally(() => {
          this.$store.commit('loading', false);
        });

      } else if ( this.marcacao.id_cadastro_temporario ) { 

        this.$util.loadItem(this, {
          service: 'arquivos',
          func: 'links',
          parms: {
            id: this.marcacao.id_cadastro_temporario,
            type: 'cadastroTemporario',
          }
        })
        .then(res => {
          this.marcacao.arquivos = res;

          if ( abrir ) {
            this.$nextTick(() => {
              this.$refs.upload.abrir();
            });
          }
        })
        .finally(() => {
          this.$store.commit('loading', false);
        });

      } else { 

        this.$util.loadItem(this, {
          service: 'arquivos',
          func: 'links',
          parms: {
            id: this.marcacao.id_pessoa,
            type: 'pessoa',
          }
        })
        .then(res => {
          this.marcacao.arquivos = res;

          if ( abrir ) {
            this.$nextTick(() => {
              this.$refs.upload.abrir();
            });
          }
        })
        .finally(() => {
          this.$store.commit('loading', false);
        });


      }

    },

    send() {
      //console.log('Enviar Mensagem');
      this.$util.atualizar(this, {
        service: 'chat',
        func: 'send',
        callback: res => {
          console.log('resposta', res);
        }
      });
    },
    painel () {
      $('#painelModal').modal('show');
    },
    status_grupo(marcacao) {
      return marcacao.item_status ? ( marcacao.item_status.valor == 'finalizado' ? { ordem: 4, texto: 'Atendidos' } :
            ( marcacao.item_status.valor == 'cancelado' ? { ordem: 5, texto: 'Cancelados', hide: true } :
              ( marcacao.id_atendimento && marcacao.dt_inicio.substr(0,10) == this.$util.hoje() ? { ordem: 3, texto: 'Em Atendimento' } :
                ( marcacao.dt_checkin ? { ordem: 2, texto: 'CheckIn' } : { ordem: 1, texto: "", hide: true } )
              )
            )
          ) : { ordem: 1, texto: "", hide: true };
    },

    chamar_proximo_para_recepcao () {

      this.$util.atualizar(this, {
        service: 'mensagens',
        func: 'chamar_proximo_para_recepcao',
        dados: {
          data: this.referencia,
          id_recepcao: this.unidade_operacao ? this.$util.getCookie('id_recepcao') : null,
          local: this.$util.getCookie('local-chamada'),
          block_painel: this.$util.getCookie('nao-enviar-painel'),
        },
        callback: res => {
          if ( res ) {
            this.$toast.add({
              severity: "success",
              summary: "Chamada Paciente",
              detail: res.msg ? res.msg : "Chamada enviada para o paciente",
              life: 5000
            });

            if ( this.marcacoes && res.id_marcacao ) {
              let marcacao = this.marcacoes.find(item => {
                return ( item.marcacao && item.marcacao.id_marcacao == res.id_marcacao );
              });

              if ( marcacao ) {
                marcacao.marcacao.st_local_recepcao = this.$util.getCookie('local-chamada');
              }
            }
          }
        }
      });

    },

    chamar_para_recepcao (marcacao, confirm_local = false) {
      $('[data-toggle="tooltip"]').tooltip("dispose");

      if ( !confirm_local && !marcacao.id_atendimento && marcacao.st_local_recepcao ) {
        if ( !confirm('ATENÇÃO: Paciente já chamado para: ' + marcacao.st_local_recepcao + '. Confirma chamar novamente?') ) {
          return;
        }

        confirm_local = true;
      }

      marcacao.item_status.loading = true;

      this.$util.atualizar(this, {
        service: 'mensagens',
        func: 'chamar_para_recepcao',
        dados: {
          id_marcacao: marcacao.id_marcacao,
          id_recepcao: this.unidade_operacao ? this.$util.getCookie('id_recepcao') : null,
          local: this.$util.getCookie('local-chamada'),
          block_painel: this.$util.getCookie('nao-enviar-painel'),
          confirm_local: confirm_local,
        },
        callback: res => {
          if ( !confirm_local && res.confirm_local && res.st_local_recepcao ) { 

            if ( !confirm('ATENÇÃO: O Paciente já foi chamado para: ' + res.st_local_recepcao + '. Confirma chamar novamente?') ) {
              return;
            }

            this.chamar_para_recepcao(marcacao, true);
            return;
          
          }

          marcacao.st_local_recepcao = this.$util.getCookie('local-chamada');

          if ( res ) {
            this.$toast.add({
              severity: "success",
              summary: "Chamada Paciente",
              detail: res.msg ? res.msg : "Chamada enviada para o paciente",
              life: 5000
            });
          }
        },
        final: () => {
          marcacao.item_status.loading = false;
        }
      })
    },
    remarcar(marcacao, trocarMedico = false) {
      if ( trocarMedico ) {
        this.$refs.alterar_prof.alterar(marcacao, () => {
          this.$util.remarcar(marcacao, trocarMedico);
        });
        return
      }

      this.$util.remarcar(marcacao, trocarMedico);
    },
    pesquisar() {
      // this.$store.commit("loading", true);

      if (this.search_timeout) clearTimeout(this.search_timeout);

      this.search_timeout = setTimeout(() => {
        this.filtrar();
        this.search_timeout = null;
      }, 300);
    },
    filtrar() {
      let items;

      if ( this.search && ( this.search.slice(0,1) == '#' || this.search.slice(0,1) == 'A' ) && !isNaN(this.search.slice(1)) ) {

        items = this.marcacoes
          ? this.marcacoes.filter(item => item.marcacao && item.marcacao.id_atendimento == this.search.slice(1))
          : [];

      } else if ( this.search && this.search.slice(0,1) == 'M' && !isNaN(this.search.slice(1)) ) {

        items = this.marcacoes
          ? this.marcacoes.filter(item => item.marcacao && item.marcacao.id_marcacao == this.search.slice(1))
          : [];

      } else if ( this.search && this.search.slice(0,3) == 'AN:' ) {

        items = this.marcacoes;

      } else {

        let pesquisar = this.search.trim();
        let parts = pesquisar.replace(" ", ".*");
        let match = parts;
        let reg = new RegExp(match, "i");

        if (pesquisar) {
          items = this.marcacoes.filter(item => {
            return reg.test(JSON.stringify(item));
            //return JSON.stringify(item).indexOf(pesquisar) >= 0;
          });
        } else {
          items = this.marcacoes;
        }

      }

      //this.lista = _.cloneDeep(items);
      this.lista = items;
      this.lista_filtros_exibicao = this.lista_filtros;

      this.$store.commit("loading", false);
    },
    tempo(mrc) {

      if (
        mrc.atendimento &&
        mrc.atendimento.progresso_atendimentos &&
        mrc.atendimento.progresso_atendimentos.length > 0
      ) {
        let fim;

        if (mrc.item_status && mrc.item_status.valor == "finalizado") {
          fim = mrc.atendimento.progresso_atendimentos.find(item => {
            return item.id_etapa_atendimento == 7;
          });
        }

        if (
          !fim &&
          mrc.atendimento.progresso_atendimentos[0].dt_conclusao.substr(
            0,
            10
          ) != moment().format("Y-MM-DD")
        ) {
          return "não finalizado";
        }

        if (
          fim &&
          fim.dt_conclusao.substr(0, 10) !=
            mrc.atendimento.progresso_atendimentos[0].dt_conclusao.substr(0, 10)
        ) {
          return "pós finalizado";
        }

        let now = fim
          ? moment(fim.dt_conclusao.substr(11, 8), "HH:mm:ss")
          : moment(this.agora, "HH:mm:ss");

        let end = moment(
          mrc.atendimento.progresso_atendimentos[0].dt_conclusao.substr(11, 8),
          "HH:mm:ss"
        );

        let diff = now.diff(end);

        let duration = moment.utc(diff).format("HH:mm");

        return duration;
      }
    },
    novoAtendimento(item) {
      if ( item && item.id_marcacao && item.id_unidade_operacao ) {

        item.hora = "";

      } else {

        if ( this.$store.state.unidade.unidade_operacaos.length == 1 ) {

          this.unidade_operacao = this.$store.state.unidade.unidade_operacaos[0].id_unidade_operacao;

        } else if ( !this.unidade_operacao && this.$store.state.unidade.unidade_operacaos.length > 1 ) {

          this.$toast.add({
            severity: "error",
            summary: "Atenção",
            detail: "Selecione a unidade.",
            life: 5000
          });

          return;

        }

      }

      let dados = {};

      if ( item ) { 

        if ( item.id_local && item.paralela ) { 
          dados.id_local = item.id_local;
        }

        dados.id_agenda = item.id_agenda;
        dados.extra = item.extra ? true : false; 
        dados.ordem_chegada = item.ordem_chegada ? true : false; 

        if ( item.coleta_dom ) { 
          dados.coleta_dom = item.coleta_dom;
        }

      }

      this.$refs.marcacao.reiniciar(dados);
      this.refHora = item ? item.hora : "";
      this.refHg = item ? item.hg : "";
      this.refUnidOper = item ? item.id_unidade_operacao : this.unidade_operacao;
      this.$refs.marcacao.extra = ( item && item.extra ) ? true : false;

      if ( item && item.id_paciente ) {
        this.$refs.marcacao.identificar_paciente(item.id_paciente, false);
      }

      if ( item ) { 

        if ( item.id_medico ) { 

          this.$util.loadItem(this, { 
            service: 'medicos',
            id: item.id_medico,
          })
          .then(res => { 

            this.$nextTick (() => { 
              if ( item.procedimento && item.procedimento.id_procedimento ) {  
                this.$refs.marcacao.selecionarProcedimento(item.procedimento);
              }

              this.$refs.marcacao.selecionarMedico(res);
            });
            
          });

        }

      }

      $("#novoAtendimento2Modal").modal("show");
    },

    novoAtendimentoComCheckIn(marcacao) {
      if ( !marcacao || !marcacao.id_unidade_operacao ) {
        this.$toast.add({
          severity: "error",
          summary: "Atenção",
          detail: "Atendimento não identificado.",
          life: 5000
        });

        return;
      } 

      this.$refs.marcacao.reiniciar({}, marcacao);

      this.$nextTick(() => { 
        this.refHora = marcacao.dt_inicio.substr(11,5);
        this.refHg =  "";
        this.refUnidOper = marcacao.id_unidade_operacao;

        if ( marcacao.id_paciente ) { 
          this.$refs.marcacao.startFluxo(2);
        } else { 
          this.$refs.marcacao.startFluxo(1);
        }
      });

      /*
      if ( item && item.id_paciente ) {
        this.$refs.marcacao.identificar_paciente(item.id_paciente, false);
      }
      */

      $("#novoAtendimento2Modal").modal("show");
    },

    load(showSpinner = true) {
      if ( this.montando )
        return;

      $('[data-toggle="tooltip"]').tooltip('dispose');

      this.acao_anexar = false;

      this.$store.commit("loading", true);

      if (showSpinner) this.lista = { agendas: {} };

      if ( this.canceltoken ) {
          this.canceltoken.cancel('#BC#');
      }

      const id_atendimento = ( this.search && isNaN(this.search) && ( this.search.substr(0,1) == '#' || this.search.substr(0,1) == 'A' ) && !isNaN(this.search.substr(1)) )
        ? this.search.substr(1)
        : null;

      const regex = new RegExp(/^[0-9]+.[0-9]+$/g, 'i');
      const enviar_search = ( this.search && regex.test(this.search) ) ? true : false;

      if ( this.id_fila_laudo && this.medico ) { 
        this.viewMode = 'A';
      }

      this.$util.setCookie('rbp', this.block_view_pacotes ? 'S' : 'N');

      let query = {
        q: [
          {
            name: "agendas.index",
            id: "lista",
            parms: {
              data: this.referencia,
              turno: this.turno, 
              medico: this.medico,
              medicos: ( this.filtro_lista_medicos && this.filtro_lista_medicos.length ) ? this.filtro_lista_medicos : null , 
              group: "none",
              livres: ( this.medico && !this.id_fila_laudo && this.tipo_proced == 'T' && this.viewMode != 'B' && this.viewMode != 'A' ) ? 1 : 0,
              status: this.viewMode == 'B' ? 'B' : 'T',
              especialidade: this.viewEspec,
              unidade_operacao: this.unidade_operacao,
              faixa_hora: ( this.filtrar_faixa_hora ? this.faixa_hora : 'D' ),
              recepcao: this.unidade_operacao ? this.$util.getCookie('id_recepcao') : null,
              page: ( this.filtrar_faixa_hora && this.faixa_hora == 'C' ? this.page : null ),
              search: ( this.tem_paginacao || this.faixa_hora != 'D' || ( isNaN(this.search) && ( this.search.slice(0,3) == 'AN:' || this.search.substr(0,1) == '#' || this.search.substr(0,1) == 'M' ) ) || enviar_search )
                ? this.search : null,
              view_status: ( this.viewStatus == 'RP' || this.tem_paginacao ) ? this.viewStatus : '',
              id_atendimento: id_atendimento,
              id_fila_laudo: this.id_fila_laudo, 
              tipo_proced: this.tipo_proced, 
              editados: this.apenas_editados, 
              agora: this.agora, 
              te_max: this.te_max,
              na_recepcao: true, 
              block_view_pacotes: this.block_view_pacotes, 
              filtro_teleatend: this.filtro_teleatend,
            }
          },
          {
            name: "atendimento_outros.index",
            id: "listaoutros",
            parms: {
              data: this.referencia,
              recepcao: true,
              id_medico: this.medico,
              id_recepcao: this.$util.getCookie('id_unidade_operacao') ? this.$util.getCookie('id_recepcao') : null
            }
          },
        ],
        modulo: 4
      };

      if (!this.medicos.length) {
        if ( !this.$store.state.options['medicos.index'] ) { 
          query.q.push({ name: "medicos.index", id: "medicos", parms: { ativos: true } });
        } else { 
          this.medicos = this.$store.state.options['medicos.index'];
        }
      }

      if ( this.medico ) {
        query.q.push({ name: "instrucoes.show", id: "instrucoes", parms: { id_medico: this.medico } });

        query.q.push({
          name: "medicos.agenda_semanal",
          id: "hormedico",
          parms: {
            id_medico: this.medico,
            data: this.referencia
          }
        });
      }

      if ( this.tem_atend_outro === null ) {

        query.q.push({
          name: 'configuracoes.index',
          id: 'configatendoutro',
          parms: {
            where: {
              st_slug: 'atendimento-outro',
              fl_ativo: '1',
            }
          }
        });

        query.q.push({
          name: 'configuracoes.index',
          id: 'recepfilaproc',
          parms: {
            where: {
              st_slug: 'recep-fila-proc',
              fl_ativo: '1',
              st_valor: '1', 
            }
          }
        });

        query.q.push({
          name: 'configuracoes.index',
          id: 'configatendfuturo',
          parms: {
            where: {
              st_slug: 'recep-atend-futuro',
              fl_ativo: '1',
              st_valor: '1', 
            }
          }
        });

        query.q.push({
          name: 'configuracoes.index',
          id: 'configalterdata',
          parms: {
            where: {
              st_slug: 'recep-alterar-data',
              fl_ativo: '1',
              st_valor: '1', 
            }
          }
        });

        query.q.push({
          name: 'configuracoes.index',
          id: 'configexibirpacotes',
          parms: {
            where: {
              st_slug: 'confirmacao-exibir-pacotes',
              fl_ativo: '1',
              st_valor: '1', 
            }
          }
        });

        

        if ( !this.$store.state.options['fila_laudo.index.proced.todas'] ) { 

          query.q.push({
            name: 'fila_laudos.index',
            id: 'filasproc',
            parms: {
              todas: true, 
            }
          });

        } else { 

          this.filas_proc = this.$store.state.options['fila_laudo.index.proced.todas'];
            
        }

      }

      this.instrucoes = null;
      this.agenda_do_medico = null;
      this.outros = null;
      this.id_fila_laudo_filtrado = null; 

      this.canceltoken = this.axios.CancelToken.source();

      //console.log('buscando', new Date().toISOString(), showSpinner);

      this.axios
        .post("/aql?a=agendas.index&page=" + this.page, query, {
            cancelToken: this.canceltoken.token
        })
        .then(res => {
          if ( !res.data )
            return;

          if ( res.data.configatendoutro && res.data.configatendoutro.status == 200 ) {
            this.tem_atend_outro = ( res.data.configatendoutro.data.length ? true : false );
          }

          if ( res.data.configalterdata && res.data.configalterdata.status == 200 ) {
            this.pode_alterar_data = ( res.data.configalterdata.data.length ? true : false );
          }

          if ( res.data.configatendfuturo && res.data.configatendfuturo.status == 200 ) {
            this.pode_atend_futuro = ( res.data.configatendfuturo.data.length ? true : false );
          }

          if ( res.data.configexibirpacotes && res.data.configexibirpacotes.status == 200 ) {
            this.conf_exibir_pacotes = ( res.data.configexibirpacotes.data.length ? true : false );
          }

          if ( res.data.recepfilaproc && res.data.recepfilaproc.status == 200 ) {
            this.tem_recep_fila_proc = ( res.data.recepfilaproc.data.length ? true : false );

            if ( res.data.filasproc && res.data.filasproc.status == 200 ) {
             
              this.filas_proc = res.data.filasproc.data.filter(fila => ( fila.fl_fila_procedimento || fila.fl_fila_enfermagem ) && fila.fl_ativo); 
            
              this.$store.commit('setOptions', { 
                name: 'fila_laudo.index.proced.todas',
                list: this.filas_proc
              });

            }

          }

          if ( res.data.lista && res.data.lista.status == 200 ) {
            this.tabela_checkin = res.data.lista.data.tabela_checkin;
            this.marcacoes = res.data.lista.data.agendas;
            this.feriado = res.data.lista.data.feriado;
            this.bloqueio = res.data.lista.data.bloqueio;
            this.pagamentos = res.data.lista.data.realiza_pagamento;
            this.paginacao = res.data.lista.data.paginate;
            this.editados = res.data.lista.data.editados;

            this.outros = res.data.listaoutros.data;

            if ( !this.paginacao )
              this.page = 1;
            else
              this.tem_paginacao = true;

            this.id_fila_laudo_filtrado = res.data.lista.data.parms 
              ? res.data.lista.data.parms.id_fila_laudo
              : null; 

            const parms_data = res.data.lista.data.parms ? res.data.lista.data.parms.data : null;

            if ( parms_data && this.referencia != parms_data )
              this.referencia = parms_data;

            this.filtrar();
          }

          if ( res.data.hormedico && res.data.hormedico.status == 200 ) {
            this.agenda_do_medico = res.data.hormedico.data;
          }

          if (!this.medicos.length) { 
            this.medicos = res.data.medicos.data;
            this.$store.commit('setOptions', { 
              name: 'medicos.index',
              list: this.medicos
            });
          }

          if ( res.data.instrucoes && res.data.instrucoes.status == 200 ) {
            this.instrucoes = res.data.instrucoes.data;
          }

          //console.log('fim', new Date().toISOString());

          this.$nextTick(() => {
            //console.log('rend', new Date().toISOString());
          });
        })
        .finally(() => {
          this.$store.commit("loading", false);
          this.firstLoad = true;
          // this.canceltoken = null;
        });
    },
    selecionarMedico(agendas) {
      this.medico = this.medico ? "" : agendas[0].marcacao.medico.id_pessoa;
      this.load();
    },
    buscaGeral() {
      this.$store.commit("loading", true);

      this.$store.commit("loading", false);
    },
    saveClick() {
      this.$emit("onSave");
      this.closeModal();
    },
    iniciar(item, etapa = 1) {

      $('[data-toggle="tooltip"]').tooltip("dispose");

      if ( item.procedimento && item.procedimento.st_procedimento == 'SEM AGENDAMENTO' ) { 
        this.novoAtendimentoComCheckIn(item);
      } else { 

        if ( !item.id_atendimento && item.st_local_recepcao && this.local && item.st_local_recepcao != this.local ) {
          if ( !confirm('Paciente já chamado para: ' + item.st_local_recepcao + '. Confirma iniciar seu atendimento?') ) {
            return;
          }
        }

        this.$refs.ini_atd.abrir(item, etapa, this.local);
      }

    },
    cancelarAtendimento(marcacao) {
      this.$refs.canc_atd.cancelar(marcacao);
    },
    printAtestado(marcacao) {
      let fim;
      let mrc;

      if (
        marcacao.item_status.valor == "finalizado" ||
        marcacao.item_status.valor == "atendido"
      ) {
        fim = marcacao.atendimento.progresso_atendimentos.find(item => {
          return (
            item.id_etapa_atendimento == 8 || item.id_etapa_atendimento == 7
          );
        });
      }
      mrc = marcacao;
      fim ? (mrc.hora_final = fim) : (mrc.hora_final = null);
      this.$refs.atestado.abrirModalAtestado(mrc);
    },
    classBackground(marcacao) {
      if (marcacao && marcacao.item_status.valor == "cancelado")
        return "atendimento-cancelado";

      if (marcacao && marcacao.item_status.valor == "chamado")
        return "atendimento-chamado";

      if ( marcacao && marcacao.atendimento && marcacao.atendimento.fl_editado_consultorio )
        return "atendimento-editado";

      if (marcacao && marcacao.item_status.valor == "em atendimento")
        return "atendimento-em-atendimento";

      if (marcacao && marcacao.item_status.medico_sem_paciente)
        return "medico-sem-paciente";

      if (marcacao && marcacao.item_status.valor == "checkin" && marcacao.st_local_recepcao == this.local )
        return "checkin-chamado";

      return "bg-white";
    },
    classBorder(marcacao) {
      let border = "atendimento-";
      if (marcacao && marcacao.item_status && marcacao.item_status.cor) {
        border = border + marcacao.item_status.cor;
      } else {
        border = border + 'primary';
      }

      return border;
    },
    teste_notificar() {
      this.axios.post("/teste_notificar", { id: 13 }).then(res => {
        console.log("NOTIFY", res);
      });
    },
    copiar_clipboard (text) {
      if (!navigator.clipboard) {
        var textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position="fixed";  //avoid scrolling to bottom
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
            console.log('Fallback: Copying text command was ' + msg);
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
        }

        document.body.removeChild(textArea);
      } else {
        navigator.clipboard.writeText(text).then(function() {
            console.log('Async: Copying to clipboard was successful!');
        }, function(err) {
            console.error('Async: Could not copy text: ', err);
        });
      }

      this.$toast.add({
        severity: "success",
        summary: "Atenção",
        detail: "Copiado para a área de transferência.",
        life: 3000
      });
    },
    refresh_local(payload) {
      if ( this.$store.state.unidade.unidade_operacaos.length > 1 )
        this.unidade_operacao = payload.id_unidade_operacao;
      else if ( this.$store.state.unidade.unidade_operacaos.length == 1 )
        this.unidade_operacao = this.$store.state.unidade.unidade_operacaos[0].id_unidade_operacao;

      let uo = this.$util.unidade_operacao();

      if ( uo ) {
        this.tem_recepcoes = ( uo.recepcaos.length > 1 ? true : false );
      } else {
        this.tem_recepcoes = false;
      }

      this.local = payload.local;
      this.te_max = payload.te_max;
      this.load();
    },

    abrir_modal_ocerizacao() {
      this.$refs.ocerizacao.open_modal();
    }
  },
  beforeMount() { 
    this.retracao['Pacientes Atendidos'] = this.$util.getCookie('RCP-Pacientes Atendidos') == 1;

    let lista = this.$util.getCookie('rlm');

    // console.log('lista', lista);

    if ( lista && lista != '[]' ) { 
      lista = JSON.parse(lista);

      if ( lista ) { 
        this.filtro_lista_medicos = lista;
      }
    }

    //

    this.block_view_pacotes = ( this.$util.getCookie('rbp') == 'S' ? true : false );
  },
  beforeDestroy () {
    EventBus.$off('refresh-local', this.refresh_local);
    // $('.tooltip').tooltip('hide');
  },
  created() {
    this.faixa_hora = this.$util.getCookie('recep-faixa-hora') ? this.$util.getCookie('recep-faixa-hora') : 'D';
  },
  mounted() {
    EventBus.$on('refresh-local', this.refresh_local);

    if ( this.$store.state.unidade.unidade_operacaos.length > 1 )
      this.unidade_operacao = this.$util.getCookie('id_unidade_operacao');
    else if ( this.$store.state.unidade.unidade_operacaos.length == 1 )
      this.unidade_operacao = this.$store.state.unidade.unidade_operacaos[0].id_unidade_operacao;

    if ( this.$util.unidade_operacao() ) {
      this.tem_recepcoes = this.$util.unidade_operacao().recepcaos.length > 1 ? true : false;
    }

    this.local = this.$util.getCookie('local-chamada');
    this.te_max = this.$util.getCookie('te-max');

    this.$store.commit("setBreadcrumb", [
      { name: "Recepção", path: "/recepcao" }
    ]);

    this.agora = moment().format("HH:mm:ss");

    this.tmaInterval = setInterval(() => {
      this.agora = moment().format("HH:mm:ss");
    }, 30000);

    if ( this.$route.params && this.$route.params.id_atendimento ) { 
      this.search = '#' + this.$route.params.id_atendimento;
    } else if ( this.$route.params && this.$route.params.nome ) { 
      this.search = this.$route.params.nome;
    } else if ( this.$route.params && this.$route.params.search ) { 
      this.search = this.$route.params.search;
    } else if ( this.$route.params && this.$route.params.id ) { 
      this.search = isNaN(this.$route.params.id) ? this.$route.params.id : '#' + this.$route.params.id;
    }

    // console.log('route', this.$route);

    this.$store.commit("loading", true);

    subscribe(this.$store.state.dominio, "chamar-paciente", retorno => {

      console.log('cp', retorno);

      let index;

      if ( this.marcacoes ) {
        index = this.marcacoes.findIndex(item => {
          if ( retorno.data.id_marcacao ) {
            return ( item.marcacao && item.marcacao.id_marcacao == retorno.data.id_marcacao );
          } else {
            return ( item.marcacao && item.marcacao.id_atendimento == retorno.data.id_atendimento );
          }
        });
      }

      // Verifica se a recepção é outra...

      if ( index >= 0 && retorno.data.id_recepcao ) {

        let recep = this.$util.recepcao();

        if ( recep 
          && retorno.data.id_recepcao != recep.id_recepcao
          && retorno.data.id_recepcao != recep.id_recepcao_mae
          && !recep.subs.find(sub => sub.id_recepcao == retorno.data.id_recepcao) ) {

          this.marcacoes.splice(index, 1);
          return;

        }
        
      }

      // Verifica se o paciente é da mesma unidade...

      if ( ( retorno.data.id_marcacao || retorno.data.id_atendimento_outro ) && retorno.data.id_unidade_operacao && this.unidade_operacao ) {
        if ( retorno.data.id_unidade_operacao != this.unidade_operacao ) {
          return;
        }
      }

      if ( retorno.data && retorno.data.msg && retorno.data.severity ) {

        if ( retorno.data.acao == 'chamar' && this.$util.getCookie('rec-sac') ) { 

          // 

        } else { 

          this.$toast.add({
            severity: retorno.data.severity,
            summary: "Atenção",
            detail: retorno.data.msg,
            life: 8000
          });

        }

        if ( this.$util.getCookie('rec-no-refresh') == 'S' ) { 
            //
        } else { 
          this.load(false);
        }

      } else if ( retorno.data.acao == 'force-refresh' ) {

        let recep = this.$util.recepcao();

        if ( recep && retorno.data.id_recepcao == recep.id_recepcao ) {
            if ( this.$util.getCookie('rec-no-refresh') == 'S' ) { 
                //
            } else {
              this.load(false);
            }
        }

      } else if ( retorno.data.acao == 'refresh' ) {

        if ( index >= 0 ) {
            if ( this.$util.getCookie('rec-no-refresh') == 'S' ) { 
                //
            } else { 
              this.load(false);
            }
        }

      } else if ( retorno.data.acao == 'chamar' ) {

        if (index >= 0) {
          const nome = this.marcacoes[index].marcacao.paciente.st_nome_social
            ? this.marcacoes[index].marcacao.paciente.st_nome_social
            : this.marcacoes[index].marcacao.paciente.st_nome;

          if ( !this.$util.getCookie('rec-sac') ) { 
          
            this.$toast.add({
              severity: retorno.data.severity ? retorno.data.severity : 'error',
              summary: "Chamada " + ( retorno.data.local ? 'em ' + retorno.data.local : '' ),
              detail: `Paciente ${nome} chamado` +
                ( retorno.data.local ? ` no(a) ${retorno.data.local}` : '.' ),
              life: 8000
            });

          }

          if ( this.$util.getCookie('recepcao-som-ao-chamar') ) {
            this.beep();
          }

        } else {
          //console.log("Fila: Não achou!", this.marcacoes);
        }
      }

      if ( ( index || index === 0 ) && index >= 0 && retorno.data.item_status ) {

        this.marcacoes[index].marcacao.st_local_recepcao = retorno.data.st_local_recepcao;
        this.marcacoes[index].marcacao.item_status = retorno.data.item_status;

        if ( retorno.data.chat_id ) {
          this.marcacoes[index].marcacao.telegram_chat_id = retorno.data.chat_id;
        }

        // Atualização dos outros procedimentos também do mesmo paciente que foram chamados.

        if ( retorno.data.outras ) {

          retorno.data.outras.forEach(id_marcacao => {
            let outra = this.marcacoes.findIndex(item => item.marcacao && item.marcacao.id_marcacao == id_marcacao);

            if ( outra || outra === 0 ) {
              this.marcacoes[outra].marcacao.st_local_recepcao = retorno.data.st_local_recepcao;
            }
          });

        }

        this.filtrar();
      }

    });

    this.montando = false;
    //this.load();

    this.$nextTick(() => {
      //console.log('r', this.$route);

      if ( this.$route.params.parmdata ) {
        this.referencia = this.$route.params.parmdata;
        this.load();
      }
    });
  },
  destroyed() {
    if (this.tmaInterval) {
      clearInterval(this.tmaInterval);
      this.tmaInterval = null;
    }
  },

  updated() {
    // $('[data-toggle="tooltip"]').tooltip();
  },

  components: {
    Marcacao,
    CancelarMarcacao,
    IniciarAtendimento,
    EtapasAtendimento,
    CelulaHorariosMarcacao,
    CelulaDadosPaciente,
    CelulaDadosProcedimento,
    AzBreakTitle,
    PrintAtestado,
    AlterarProcedimento,
    AlterarUnidade, 
    AlterarProfissionalSolicitante, 
    AlterarApoiado, 
    AzFileUpload,
    DocumentoPreAtendimento,
    AzInput,
    AlterarProfissional,
    AzSubmit,
    EmitirEtiqueta,
    Documento,
    Amostras,
    AgendaDoMedico,
    ListaAtendOutros,
    CheckIn,
    ValidarIntegracao, 
    ImportarExterno, 
    OutrosChamada, 
    AlterarData, 
    AzOcerizator, 
    SelecaoMedicoLista,
    HistoricoPacotesPaciente,
    VerFilaConsultorio, 
    LaudosPrazoEntrega, 
    VerAutorizacao
  }
};
</script>

<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}

.modal-dialog2 {
  width: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}

.atendimento-danger {
  border-left: 4px solid #dc3545;
}
.atendimento-success {
  border-left: 4px solid #28a745;
}
.atendimento-dark {
  border-left: 4px solid #343a40;
}
.atendimento-warning {
  border-left: 4px solid #ffc107;
}
.atendimento-primary {
  border-left: 4px solid #007bff;
}

.atendimento-editado {
  background-color: turquoise;
}

.atendimento-chamado {
  background-color: #fff3cd;
}

.atendimento-cancelado {
  background-color: lightgray;
}

.atendimento-em-atendimento {
  background-color: lightgreen;
}

.medico-sem-paciente {
  background-color: #b8daff;
}

.checkin-chamado {
  background-color: #fff3cd;
}
</style>

<!-- #lightcoral -->